module.exports = __webpack_public_path__ + "static/img/courseSelection.dfbda372.svg";